export default "/images/pie-chart.svg?8359ca2bd0c76759b6d82c1065740642";